import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { grey9 } from 'approot/shared/styles/colours.style';
import { ellipsisCss } from 'approot/shared/styles/typography.style';
import {
  LinkButton,
  SecondaryButton,
} from 'approot/shared/styles/buttons/buttons';
import { Row, Col } from 'approot/shared/grid/grid';

export const OutcomeButton = styled(LinkButton)`
  color: ${grey9};
  text-align: left;
`;

export const OutcomeText = styled.span`
  color: ${grey9};
  text-align: left;
  font-size: inherit;
`;

export const OutcomesContainer = styled.div``;

export const OutcomesRow = styled(Row)``;

export const OutcomesCol = styled(Col)`
  margin-bottom: ${rem(spacing24)};
`;

export const OutcomeList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-top: ${rem(spacing12)};
  }
`;

export const OutcomeLinkList = styled(OutcomeList)`
  margin-bottom: ${rem(spacing12)};
  li {
    display: inline-block;
    margin: 0 ${rem(spacing16)} ${rem(spacing12)} 0;
  }
`;

export const OutcomePill = styled(SecondaryButton).attrs({
  $isSmall: true,
})`
  ${ellipsisCss}
  height: auto;
  border-radius: ${rem(32)};
  padding-top: ${rem(spacing8)};
  padding-bottom: ${rem(spacing8)};
  max-width: 100%;
`;
